export enum GeoType {
    PostalCode = "postalCode",
    Place = "place",
    Custom = "custom",
}
